(function(angular){
    angular.module('bizPartEngage').service('core.unit.service', unitService);

    unitService.$inject = ["$http"];

    function unitService($http) {
        this.GetUsersInUnit = function(unitId) {
            return $http.get(siteRootPath + 'api/Unit/GetUsersInUnit?' + $.param({unitId: unitId}));
        };

        this.GetUnitsByParent = function(parentId) {
            return $http.get(siteRootPath + 'api/Unit/GetUnitsByParent?' + $.param({ parentId: parentId }));
        };
    }
})(window.angular);
